import React from "react";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const statusColors = {
  New: "red",
  Processing: "hsl(240, 56%, 64%)",
  Completed: "rgb(90, 150, 93)",
  Canceled: "#af586b",
};

// @ts-ignore
const StatusLabel = styled(Box)(({ theme, status }) => ({
  margin: 0,
  padding: "0 5px",
  width: "100%",
  height: "100%",
  borderRadius: "8px",
  color: theme.palette.common.white,
  backgroundColor: statusColors[status] || theme.palette.grey[500],
  textAlign: "center",
  display: "block",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
}));

const Status = ({ value, bigger = null }) => {
  return value ? (
    <StatusLabel
      // @ts-ignore
      status={value}
      bigger={bigger}
    >
      {value}
    </StatusLabel>
  ) : null;
};

export default Status;
